import { RoadDto } from "../services/bbo-client.service";
import { SelectableOption } from "./purview.model";

export class RoadDirection implements SelectableOption {
	name: string;
	/** direction id aka rfb (Richtungsfahrbahn). */
	id: 1 | 2;

	constructor(name: string, id: 1 | 2) {
		this.name = name;
		this.id = id;
	}
}

export class Road implements SelectableOption {
	id: string;
	name: string;
	startKm?: number;
	endKm?: number;
	code: string;
	shortCode: string;
	longText: string;
	direction1?: string;
	direction2?: string;

	constructor(res: RoadDto) {
		this.id = res.id as string;
		this.name = `${res.roadCodeShortTxt} - ${res.roadLongTxt}`;
		this.startKm = res.startKm;
		this.endKm = res.endKm;
		this.code = res.roadCode as string;
		this.shortCode = res.roadCodeShortTxt as string;
		this.longText = res.roadLongTxt as string;
		this.direction1 = res.roadDestination1;
		this.direction2 = res.roadDestination2;
	}

	/**
	 * Get the selectable road direction options from this road.
	 * Skips options where the direction is not set.
	 * The array is empty if this road provides no directions (direction1 and 2 are undefined).
	 */
	get DirectionOptions(): RoadDirection[] {
		const roadDirections: RoadDirection[] = [];
		if (this.direction1) {
			roadDirections.push(new RoadDirection(this.direction1, 1));
		}
		if (this.direction2) {
			roadDirections.push(new RoadDirection(this.direction2, 2));
		}
		return roadDirections;
	}
}
